// extracted by mini-css-extract-plugin
export default {"container":"PaymentWalletInfo_container__fR+ec","infoText":"PaymentWalletInfo_infoText__h3siw","walletIcon":"PaymentWalletInfo_walletIcon__ILmt+"};